import Util from './util';


const getBEMModal = (el, mod) => Util.getBEM('modal', el, mod);
const cls = Util.cls;
const config = {
    sel: {
        base: getBEMModal(),
        visible: getBEMModal(null, 'visible'),
        trigger: {
            base: getBEMModal('trigger'),
            open: getBEMModal('trigger', 'open'),
            close: getBEMModal('trigger', 'close'),
            nobubble: getBEMModal('trigger', 'nobubble'),
        },
        wrapContent: '#wrap-content',
        wrapOffscreen: '#wrap-offscreen',
        wrapContentBlurred: '.blurred',
    },
};

function _getModalByTrigger($el) {
    const modalId = $el.data('modal-id');

    // if no modal-id is present, the trigger should live inside a modal
    if(Util.isNull(modalId)) return $el.closest(config.sel.base);
    return $(config.sel.base + `[data-modal-id="${modalId}"]`);
}

function toggleByEv(ev, state = false) {
    const $target = $(ev.currentTarget);

    if ($target.hasClass(cls(config.sel.trigger.nobubble)) && ev.target !== ev.currentTarget) return;
    toggle(_getModalByTrigger($target), state);
}

function toggleById(id, state = false) {
    const modal = $(`${config.sel.base}[data-modal-id="${id}"]`);
    toggle(modal, state);
}

function toggle(modal, state = false) {
    const fn = state ? 'addClass' : 'removeClass';
    modal.appendTo($(config.sel.wrapOffscreen));                         // prevent modal to be blurred
    setTimeout(() => modal[fn](cls(config.sel.visible)), 10);            // add / remove visible class after dom re-render
    $(config.sel.wrapContent)[fn](cls(config.sel.wrapContentBlurred));   // blur the rest of the page
}

function onTrigger(ev) {
    const $target = $(ev.target);
    let data = {
        target: $target,
        modal: _getModalByTrigger($target),
        type: $target.data('modal-trigger-type')
    };

    $(document).trigger('modal--trigger', data);
}

$(() => {
    $(document)
        .on('click', config.sel.trigger.base, (ev) => onTrigger(ev))
        .on('click', config.sel.trigger.open, (ev) => toggleByEv(ev, true))
        .on('click', config.sel.trigger.close, (ev) => toggleByEv(ev, false))
});

export default {
    toggleById
}